const uploadDictionary = {
  upload: {
    addButton: {
      text: "Upload files",
      subText: "or drag & drop"
    },
    selectButton: {
      text: "Select files"
    },
    selectModal: {
      maxLimitReached: "Maximum amount of items reached"
    },
    insertSelected: {
      text: "Confirm"
    },
    fileState: {
      inspectingFile: "Inspecting file…",
      invalidFile: "Invalid file",
      failedUpload: "Upload failed",
      finalizing: "Finalizing…"
    }
  }
};
export {
  uploadDictionary
};
//# sourceMappingURL=uploadDictionary.js.map
